module.exports = __webpack_public_path__ + "static/media/box.a76cbaef.png";